import fp from 'lodash/fp';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SingleDatePicker } from 'react-dates';
import { noop } from 'lodash';
import classnames from 'classnames';
import Checkbox from '../../../../../../common/checkbox/Checkbox';
import CalendarIcon from '../../../../../../common/Icons/Calendar.svg';
import CrossIcon from '../../../../../../common/Icons/Cross.svg';
import { dateDisplayFormat, dateTransferFormat } from '../../../../../../common/constants';
import { dateTimeToMoment } from '../../../../../../common/helpers';
import filterDefinitionPropType from '../../../../filterDefinitionPropType';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import defaultStyles from './DatePillModal.module.scss';

const comparisonFormat = 'YYYYMMDD';

class DatePillModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fromFocused: false,
            toFocused: false
        };

        this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);

        this.hasOneInputOnly = () => this.props.filterDefinition.fromOnly
            || this.props.filterDefinition.toOnly
            || this.props.filterDefinition.singleDay;
    }

    componentDidMount() {
        const form = this.props.value;
        this.props.setUpState(
            this.calculateValue(form),
            form,
            this.calculateValueIsBlank(this.props.value)
        );
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.fromFocused && !this.state.fromFocused) {
            this.props.setPillFocus();
        }
    }

    componentWillUnmount() {
        this.props.resetFilter();
    }

    handleCheckBoxChange(value) {
        const values = {
            today: value
        };
        if (value) {
            values.from = null;
            values.to = null;
        }
        this.props.handleUpdates(values);
    }

    getEmptyValues() {
        return {
            value: this.calculateValue({}),
            form: {}
        };
    }

    calculateValueIsBlank(formState) {
        const calcVal = this.calculateValue(formState);
        return !calcVal.from && !calcVal.to && !calcVal.today;
    }

    // eslint-disable-next-line class-methods-use-this
    calculateValue(formState) {
        return {
            from: formState.from || null,
            to: formState.to || null,
            today: formState.today || false
        };
    }

    calculateValueIsValid(formState) {
        return !!(!this.props.filterDefinition.useValidation
            || (
                formState.today
                || (formState.from && formState.to)
                || (this.props.filterDefinition.fromOnly && formState.from)
                || (this.props.filterDefinition.toOnly && formState.to)
            ));
    }

    render() {
        const { styles } = this.props;
        return (
            <div>
                <div
                    className={ classnames({
                        [styles['dates-wrapper']]: true,
                        [styles.singleDay]: this.hasOneInputOnly(),
                    }) }
                >
                    { !this.props.filterDefinition.toOnly && (
                        <SingleDatePicker
                            date={ this.props.value.from
                                ? dateTimeToMoment(this.props.value.from) : null }
                            disabled={ false }
                            onDateChange={ (date) => (date !== null
                                ? this.props.handleUpdate('from', date.format(dateTransferFormat))
                                : this.props.handleUpdate('from', null)) } // PropTypes.func.isRequired
                            focused={ this.state.fromFocused } // PropTypes.bool
                            onFocusChange={
                                ({ focused }) => this.setState({ fromFocused: focused })
                            } // PropTypes.func.isRequired
                            id={ `date-${this.props.filter.title}-from` } // PropTypes.string.isRequired
                            numberOfMonths={ 1 }
                            displayFormat={ dateDisplayFormat }
                            firstDayOfWeek={ 1 }
                            isOutsideRange={ (date) => (
                                this.props.value.to === null
                                    ? false
                                    : dateTimeToMoment(date).format(comparisonFormat)
                                        > dateTimeToMoment(this.props.value.to)
                                            .format(comparisonFormat)
                            ) }
                            showClearDate
                            customInputIcon={ (
                                <img
                                    className={ styles.calendarIcon }
                                    src={ CalendarIcon }
                                    alt="Calender"
                                />
                            ) }
                            customCloseIcon={ (
                                <img
                                    className={ styles.clearDate }
                                    src={ CrossIcon }
                                    alt="Cross"
                                />
                            ) }
                            small
                            hideKeyboardShortcutsPanel
                        />
                    ) }
                    { !this.props.filterDefinition.fromOnly && (

                        <SingleDatePicker
                            date={ this.props.value.to
                                ? dateTimeToMoment(this.props.value.to) : null }
                            disabled={ false }
                            onDateChange={ (date) => (date !== null
                                ? this.props.handleUpdate('to', date.format(dateTransferFormat))
                                : this.props.handleUpdate('to', null)) } // PropTypes.func.isRequired
                            focused={ this.state.toFocused } // PropTypes.bool
                            onFocusChange={
                                ({ focused }) => this.setState({ toFocused: focused })
                            } // PropTypes.func.isRequired
                            id={ `date-${this.props.filter.title}-to` } // PropTypes.string.isRequired
                            numberOfMonths={ 1 }
                            displayFormat={ dateDisplayFormat }
                            firstDayOfWeek={ 1 }
                            isOutsideRange={ (date) => (
                                this.props.value.from === null
                                    ? false
                                    : dateTimeToMoment(date).format(comparisonFormat)
                                        < dateTimeToMoment(this.props.value.from)
                                            .format(comparisonFormat)
                            ) }
                            showClearDate
                            customInputIcon={ (
                                <img
                                    className={ styles.calendarIcon }
                                    src={ CalendarIcon }
                                    alt="Calender"
                                />
                            ) }
                            customCloseIcon={ (
                                <img
                                    className={ styles.clearDate }
                                    src={ CrossIcon }
                                    alt="Cross"
                                />
                            ) }
                            small
                            hideKeyboardShortcutsPanel
                        />
                    ) }
                </div>
                { !fp.get('props.filterDefinition.hideToday')(this) && (
                    <div className={ styles['date-filter-today-wrapper'] }>
                        <div className={ styles['today-title'] }>
                            Today
                        </div>
                        <div className={ styles['checkbox-wrapper'] }>
                            <Checkbox
                                checked={ this.props.value.today }
                                onChange={ (checked) => this.handleCheckBoxChange(checked) }
                            />
                        </div>
                    </div>
                ) }
            </div>
        );
    }
}

DatePillModal.propTypes = {
    filter: PropTypes.shape({
        title: PropTypes.string.isRequired,
        value: PropTypes.shape({
            from: PropTypes.string,
            to: PropTypes.string,
            today: PropTypes.bool
        }),
        fromOnly: PropTypes.bool,
        toOnly: PropTypes.bool
    }),
    value: PropTypes.shape({
        from: PropTypes.string,
        to: PropTypes.string,
        today: PropTypes.bool
    }),
    handleUpdate: PropTypes.func.isRequired,
    handleUpdates: PropTypes.func.isRequired,
    setUpState: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired,
    styles: PropTypes.objectOf(PropTypes.string),
    filterDefinition: filterDefinitionPropType.isRequired,
    setPillFocus: PropTypes.func
};

DatePillModal.defaultProps = {
    filter: {
        value: {
            from: null,
            to: null,
            today: false
        },
        fromOnly: false,
        toOnly: false
    },
    value: {
        from: null,
        to: null,
        today: false
    },
    styles: defaultStyles,
    setPillFocus: noop
};

export default DatePillModal;
